<template>
  <div class="user-page__content">
    <div class="form">
      <div class="form__row">
        <div class="form__col-4">
          <InputComponent
            v-model.trim="form.surname.value"
            :error="form.surname.error"
            title="Фамилия*"
            placeholder="Фамилия*"
          />
        </div>
        <div class="form__col-4">
          <InputComponent
            v-model.trim="form.name.value"
            :error="form.name.error"
            title="Имя*"
            placeholder="Имя*"
          />
        </div>
        <div class="form__col-4">
          <InputComponent
            v-model.trim="form.patronymic.value"
            :error="form.patronymic.error"
            title="Отчество*"
            placeholder="Отчество*"
          />
        </div>
        <div class="form__col-6">
          <InputComponent
            v-model="form.phone.value"
            :error="form.phone.error"
            title="Контактный телефон*"
            placeholder="+7 (___) ___-__-__"
            mask="+7 (###) ### - ## - ##"
          />
        </div>
        <div class="form__col-6">
          <InputComponent
            v-model.trim="form.email.value"
            :error="form.email.error"
            title="Email*"
            placeholder="Email*"
          />
        </div>
      </div>
      <CheckboxComponent :checked="subscription" @change="subscription = !subscription">
        <span> Хочу получать наши Спецпредложения и Акции </span>
      </CheckboxComponent>
      <div class="user-page__footer">
        <button @click="profileUpdate" type="button" class="btn btn--md btn--main">
          <template v-if="profileUpdateLoading">Сохранение...</template>
          <template v-else>Сохранить</template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import InputComponent from "components/inputs/InputComponent.vue";
import USER_PROFILE_UPDATE from "gql/auth/UserProfileUpdate.graphql";
import USER_PHONE_UPDATE from "gql/auth/UserPhoneUpdate.graphql";
import CheckboxComponent from "components/inputs/CheckboxComponent.vue";

export default {
  name: "ProfilePage",
  data() {
    return {
      subscription: true,
      profileUpdateLoading: false,
      phoneUpdateLoading: false,
      form: {
        surname: {
          value: undefined,
          message: undefined,
          error: undefined,
        },
        name: {
          value: undefined,
          message: undefined,
          error: undefined,
        },
        patronymic: {
          value: undefined,
          message: undefined,
          error: undefined,
        },
        email: {
          value: undefined,
          message: undefined,
          error: undefined,
        },
        phone: {
          value: undefined,
          message: undefined,
          error: undefined,
        },
      },
    };
  },
  mounted() {
    this.setProfileData();
  },
  watch: {
    "$store.state.auth.user"() {
      this.setProfileData();
    },
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    setProfileData() {
      if (this.user) {
        this.form.name.value = this.user.name;
        this.form.surname.value = this.user.surname;
        this.form.patronymic.value = this.user.patronymic;
        this.form.email.value = this.user.email;
        this.form.phone.value = this.user.phone;
      }
    },
    async profileUpdate() {
      if (!this.profileUpdateLoading) {
        this.resetErrors("form");
        this.profileUpdateLoading = true;
        await this.$apollo.provider.defaultClient
          .mutate({
            mutation: USER_PROFILE_UPDATE,
            variables: {
              surname: this.form.surname.value || undefined,
              name: this.form.name.value || undefined,
              patronymic: this.form.patronymic.value || undefined,
              email: this.form.email.value || undefined,
            },
            context: {
              headers: {
                Authorization: "Bearer " + this.$store.state.apollo_token,
              },
            },
          })
          .then(({ data }) => {
            if (data && data.UserProfileUpdate) {
              this.$store.state.auth.user = data.UserProfileUpdate.user;
              this.$notify({
                title: "Сохранено",
                text: data.UserProfileUpdate.message,
                duration: 5000,
                speed: 200,
                type: "success",
              });
            }
            this.profileUpdateLoading = false;
          })
          .catch(({ graphQLErrors }) => {
            this.profileUpdateLoading = false;
            this.parseGqlErrors(graphQLErrors, "form");
          });
      }
    },
    phoneUpdate() {
      if (!this.loading) {
        this.loading = true;
        this.$apollo.provider.defaultClient
          .mutate({
            mutation: USER_PHONE_UPDATE,
            variables: {
              phone: "+" + this.form.phone.value.replace(/\D+/g, ""),
            },
            context: {
              headers: {
                Authorization: "Bearer " + this.$store.state.apollo_token,
              },
            },
          })
          .then(() => {
            this.loading = false;
            // показать модалку с вводом кода
            // this.$store.state._modals.push({
            //   component: PhoneConfirmModal,
            //   options: {},
            // });
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    resetErrors(form) {
      Object.keys(this[form]).forEach((key) => {
        this[form][key].error = undefined;
      });
    },
    parseGqlErrors(graphQLErrors) {
      graphQLErrors.forEach((err) => {
        if (err.extensions.category === "validation") {
          Object.keys(err.extensions.validation).forEach((key) => {
            if (this.form[key]) {
              this.form[key].error = err.extensions.validation[key][0];
            }
          });
        }
      });
    },
  },
  components: { CheckboxComponent, InputComponent },
};
</script>

<style lang="stylus">
.user-page {
  .form__row {
    .input {
      width 100%
    }

    .form__col-4 {
      +below(680px) {
        flex-basis calc(100% - 16px)
      }
    }

    .form__col-6 {
      +below(860px) {
        gap 16px
      }
      +below(680px) {
        flex-basis calc(100% - 16px)
      }
    }
  }
}
</style>
